import { Box, Card, CardActionArea, type SxProps, type Theme } from '@mui/material';

interface MobileCardListProps<T> {
  items: T[];
  renderCard: (item: T, index: number) => React.ReactNode;
  onItemClick?: (item: T) => void;
  sx?: SxProps<Theme>;
}

export function MobileCardList<T>({
  items,
  renderCard,
  onItemClick,
  sx,
}: MobileCardListProps<T>) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, ...sx }}>
      {items.map((item, index) =>
        onItemClick ? (
          <Card key={index} variant="outlined">
            <CardActionArea onClick={() => onItemClick(item)} sx={{ p: 2 }}>
              {renderCard(item, index)}
            </CardActionArea>
          </Card>
        ) : (
          <Card key={index} variant="outlined" sx={{ p: 2 }}>
            {renderCard(item, index)}
          </Card>
        )
      )}
    </Box>
  );
}
